import type { Signal } from '@angular/core';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { DnvUserRoleType } from '@customer-portal/shared';
import { CoBrowsingCompany } from '@customer-portal/shared/models';

import {
  GetCompanySuggestions,
  ResetSelectedCobrowsingCompany,
  UpdateDnvUserAccessType,
  UpdateImpersonatedUser,
  UpdateIsDnvUser,
  UpdateSelectedCobrowsingCompany,
} from '../actions';
import { CoBrowsingSelectors } from '../selectors';

@Injectable({ providedIn: 'root' })
export class SettingsCoBrowsingStoreService {
  get selectedCoBrowsingCompany(): Signal<CoBrowsingCompany | null> {
    return this.store.selectSignal(
      CoBrowsingSelectors.selectedCoBrowsingCompany,
    );
  }

  get isDnvUser(): Signal<boolean> {
    return this.store.selectSignal(CoBrowsingSelectors.isDnvUser);
  }

  get companySuggestions(): Signal<CoBrowsingCompany[]> {
    return this.store.selectSignal(CoBrowsingSelectors.companySuggestions);
  }

  get companySuggestionError(): Signal<string> {
    return this.store.selectSignal(CoBrowsingSelectors.companySuggestionError);
  }

  get isLoadingCompanySuggestions(): Signal<boolean> {
    return this.store.selectSignal(
      CoBrowsingSelectors.isLoadingCompanySuggestions,
    );
  }

  constructor(private store: Store) {}

  @Dispatch()
  updateIsDnvUser = (isDnvUser: boolean) => new UpdateIsDnvUser(isDnvUser);

  @Dispatch()
  updateDnvUserAccessType = (dnvUserAccessType: DnvUserRoleType) =>
    new UpdateDnvUserAccessType(dnvUserAccessType);

  @Dispatch()
  updateSelectedCoBrowsingCompany = (selectedCompany: CoBrowsingCompany) =>
    new UpdateSelectedCobrowsingCompany(selectedCompany);

  @Dispatch()
  resetSelectedCobrowsingCompany = () => new ResetSelectedCobrowsingCompany();

  @Dispatch()
  updateImpersonatedUser = (impersonatedUser: string | null) =>
    new UpdateImpersonatedUser(impersonatedUser);

  @Dispatch()
  getCompanySuggestions = (searchText: string) =>
    new GetCompanySuggestions(searchText);
}
